module.exports = __webpack_public_path__ + "img/logo.7bf9a807.png";